var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assigned-input"},[_c('task-queue-select',{staticClass:"es-simple only-text",attrs:{"project":_vm.task.project ? _vm.task.project.id : null,"with-no-project":"","disable":_vm.disable},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }